import { Modal } from 'antd'
import { graphQLErrorCode } from '~/utils'
import Router from 'next/router'

export const useValidateIntergal = () => {
  const IsNotEnough = (err: any) => {
    return graphQLErrorCode(err) === 20110010
  }
  const intergalModal = () => {
    return Modal.confirm({
      title: '提示',
      maskStyle: {
        backgroundColor: 'rgba(0,0,0,0.8)',
      },
      width: 270,
      className: 'hookModal dark',
      content: (
        <div className="text-neutral-400 text-sm text-center">
          剩余积分不足，是否充值积分？
        </div>
      ),
      okText: '前往充值',
      onOk: close => {
        Router.push('/integral')
        close()
      },
      onCancel: close => {
        close()
      },
    })
  }

  return {
    /** 是否积分不足 */
    IsNotEnough,
    /** 积分不足提示弹窗 */
    intergalModal,
  }
}
